import * as Sentry from '@sentry/react'
import React from 'react'
import { createRoot } from 'react-dom/client'

import App from 'App'
import Env from 'config/Env'
import 'config/i18n'
import 'index.css'
import reportWebVitals from 'reportWebVitals'
import { scrubBreadcrumb, scrubEvent } from 'utils/sentryServices/scrubSentryData'

// Initialize Sentry
Sentry.init({
  dsn: 'https://92d538d910957da635f8ce949c76ca30@o4506780963766272.ingest.us.sentry.io/4506954118463488',
  environment: Env.NODE_ENV,
  // Local development runs against real data, and the log helpers already skip local, so
  // the SDK is switched off entirely rather than shipping breadcrumbs and traces (16919).
  enabled: !Env.isLocal(),
  // Session Replay is deliberately not enabled: a recording captures every patient detail
  // rendered on screen, which no amount of event scrubbing can remove (US 16919).
  integrations: [Sentry.browserTracingIntegration()],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of transactions
  tracePropagationTargets: ['localhost'],
  // PHI safeguards — applied to every event, including unhandled errors.
  sendDefaultPii: false,
  beforeSend: event => scrubEvent(event),
  beforeSendTransaction: event => scrubEvent(event),
  beforeBreadcrumb: breadcrumb => scrubBreadcrumb(breadcrumb),
})

// Create root using React 18 API
const container = document.getElementById('root')
if (!container) throw new Error('Root container not found')

const root = createRoot(container)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// If you want to start measuring performance in your app
// pass a function to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint.
reportWebVitals()
